module.exports = join;

function join(targets, hint) {
  if (!targets.length) {
    return new Uint8Array(0);
  }

  var len = hint !== undefined ? hint : get_length(targets),
      out = new Uint8Array(len),
      cur = targets[0],
      curlen = cur.length,
      curidx = 0,
      curoff = 0,
      i = 0;

  while (i < len) {
    if (curoff === curlen) {
      curoff = 0;
      ++curidx;
      cur = targets[curidx];
      curlen = cur && cur.length;
      continue;
    }

    out[i++] = cur[curoff++];
  }

  return out;
}

function get_length(targets) {
  var size = 0;

  for (var i = 0, len = targets.length; i < len; ++i) {
    size += targets[i].byteLength;
  }

  return size;
}